export enum WorkflowType {
    "Price Claim" = 1,
    "Inventory/Uplift/RMA" = 2,
    "Ad hoc" = 3    
}